import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { CurrencyModel } from '@root/entities/currency'
import { Network } from '@root/entities/network'
import { walletDtoUpdateReceivedAction } from '@root/entities/wallet/atoms'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'
import { reatomRequest } from '@root/shared/lib'

import type { WalletModel } from '@root/entities/wallet'
import type { EditAssetReqDto } from '@root/shared/api/WalletApi'

export const editWalletAssetRequestAction = action(
  async (ctx, req: EditAssetReqDto) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.wallet.walletEditAssetCreate, [req]),
    )

    const mappedResult = pipe(
      result,
      Result.mapError(ApiError.fallbackToUnknown),
    )

    if (Result.isSuccess(result)) {
      walletDtoUpdateReceivedAction(ctx, result.success)
    }

    return mappedResult
  },
  'editWalletAssetRequestAction',
)
export const reatomToggleWalletAsset = ({
  wallet,
  currency,
}: {
  wallet: WalletModel
  currency: CurrencyModel
}) => {
  const toggleAssetInternalAction = action(async (ctx) => {
    const assets = ctx.get(wallet.assets)
    const existingAsset = assets.find((it) =>
      CurrencyModel.eq(it.currency, currency),
    )

    return editWalletAssetRequestAction(ctx, {
      walletId: wallet.id,
      asset: {
        network: Network.toDto(currency.network),
        address: currency.address,
        //hidden is actually a toggle, if false - add asset, true - toggle visibility
        hidden: Boolean(existingAsset),
      },
    })
  }, 'toggleAssetInternalAction')

  const requestState = reatomRequest({
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: `reatomUpdateAssets_${wallet.id}_${currency.address}`,
    execAction: toggleAssetInternalAction,
  })

  return requestState
}
